import { render, staticRenderFns } from "./OrganizationDashboardSection.vue?vue&type=template&id=b23de3a4&scoped=true"
import script from "./OrganizationDashboardSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationDashboardSection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationDashboardSection.vue?vue&type=style&index=0&id=b23de3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23de3a4",
  null
  
)

export default component.exports